export default __webpack_public_path__ + "static/media/7.065140d0.webp";